import { render } from "./trade-book-export.vue?vue&type=template&id=25ebf05c&scoped=true"
import script from "./trade-book-export.vue?vue&type=script&lang=js"
export * from "./trade-book-export.vue?vue&type=script&lang=js"

import "./trade-book-export.vue?vue&type=style&index=0&id=25ebf05c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ebf05c"]])

export default __exports__